import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Field } from "@/components/StatusBits";
import { label } from "@/lib/api";

const OBJECTIVES = [
  ["collections", "Collections / account follow-up"], ["approval", "Approval notification"],
  ["application", "Application / document follow-up"], ["followup", "General follow-up"], ["custom", "Custom objective"],
];

export const BriefingFields = ({ value, onChange, prefix = "briefing", compact }) => {
  const set = (k) => (e) => onChange({ ...value, [k]: e?.target ? e.target.value : e });
  const rows = compact ? 2 : 3;
  return (
    <div className="space-y-3">
      <div className="grid grid-cols-2 gap-2">
        <Field label="Objective">
          <Select value={value.objective_type || "followup"} onValueChange={set("objective_type")}>
            <SelectTrigger data-testid={`${prefix}-objective-select`} className="h-9 bg-white text-xs"><SelectValue /></SelectTrigger>
            <SelectContent className="bg-white">
              {OBJECTIVES.map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}
            </SelectContent>
          </Select>
        </Field>
        <Field label="Tone">
          <Select value={value.tone || "professional"} onValueChange={set("tone")}>
            <SelectTrigger data-testid={`${prefix}-tone-select`} className="h-9 bg-white text-xs"><SelectValue /></SelectTrigger>
            <SelectContent className="bg-white">
              {["friendly", "professional", "firm"].map((t) => <SelectItem key={t} value={t}>{label(t)}</SelectItem>)}
            </SelectContent>
          </Select>
        </Field>
      </div>
      <Field label="Call objective (optional override)">
        <Textarea rows={rows} data-testid={`${prefix}-call-objective`} value={value.call_objective || ""} onChange={set("call_objective")} placeholder="What should this call achieve?" />
      </Field>
      <Field label="Opening line" hint="Merge fields like {first_name}, {business_name}, {amount_owed}">
        <Input data-testid={`${prefix}-opening-line`} value={value.opening_line || ""} onChange={set("opening_line")} placeholder="Uses the script's opening line if empty" />
      </Field>
      <Field label="Relevant contact / account information">
        <Textarea rows={rows} data-testid={`${prefix}-context`} value={value.context || ""} onChange={set("context")} />
      </Field>
      <Field label="Special instructions">
        <Textarea rows={rows} data-testid={`${prefix}-special-instructions`} value={value.special_instructions || ""} onChange={set("special_instructions")} />
      </Field>
      <Field label="Callback / follow-up instructions">
        <Textarea rows={rows} data-testid={`${prefix}-callback-instructions`} value={value.callback_instructions || ""} onChange={set("callback_instructions")} />
      </Field>
    </div>
  );
};
